import { ObjectReferences } from './../../interfaces';
import { fetchData } from './fetchData';

export const GetReferences = (id: string): Promise<Array<ObjectReferences>> => {
    return fetchData(`/SystemApi/GetReferences?id=${id}`, 'GET')
        .then((response) => {
            return response.json();
        })
        .catch((error) => {
            console.error('error', error);
            throw error;
        });
};
